import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private numeroPeticiones = 0;
  loading = signal(false);
  show() {
    this.numeroPeticiones++;
    this.loading.set(true);
  }

  hide() {
    this.numeroPeticiones--;
    if (this.numeroPeticiones <= 0) {
      this.loading.set(false);
    }
  }
}
